<template>
  <a-card class="Traingame">
    <div style="margin-bottom: 15px;" @keyup.enter="searchList(1)">
      <a-form-model layout="inline">
        <a-form-model-item label="游戏名称">
          <a-input allowClear placeholder="请输入游戏名称" :maxLength="20" v-model="search.Name"/>
        </a-form-model-item>
        <a-form-model-item label="版本名称">
          <a-input allowClear placeholder="请输入版本名称" :maxLength="20" v-model="search.versionName"/>
        </a-form-model-item>
        <a-form-model-item label="质量标准">
          <a-select allowClear v-model="search.classifyTag" placeholder="请选择状态" style="width:198px;">
            <a-select-option value="1">商用</a-select-option>
            <a-select-option value="4">科研</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="能力维度">
          <a-cascader v-model="selectId"
                  :options="options"
                  :load-data="loadData"
                  placeholder="请选择能力维度"
                  change-on-select
                  @change="onChange"/>
        </a-form-model-item>
        <a-form-model-item label="适用年龄">
          <a-input-group compact>
            <a-input-number style=" width: 100px; text-align: center" placeholder="最小年龄" type="number" :precision="0" :min="1" :max="150" v-model="search.minAge"/>
            <a-input style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled/>
            <a-input-number style="width: 100px; text-align: center;border-left:none;" placeholder="最大年龄" :precision="0" :min="search.minAge" :max="150"  type="number" v-model="search.maxAge" />
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select allowClear v-model="search.Enabled" placeholder="请选择状态" style="width:198px;">
            <a-select-option value="true">启用</a-select-option>
            <a-select-option value="false">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="searchList(1)">查询</a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`/content/Traingame/TraingameSeting`">
          <a-button @click="addEgame()" type="primary" icon="plus">添加游戏</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div>
      <a-table
        :customRow="customRow"
        :loading="loading"
        ref="myGamesTable"
        :columns="columns"
        :data-source="dataSource"
        rowKey="id"
        class="components-table-demo-nested"
        			@change="changeSort"
        :pagination="{
          current: search.PageIndex,
          pageSize: search.PageSize,
          total: total,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onSizeChange,
        }"
      >
        <div slot="classifyTag" slot-scope="text,record">
          {{text.classifyTag == 1 ? '商用' : text.classifyTag == 4 ? '科研' : '--'}}
        </div>
        <div slot="abilityTypeName" slot-scope="text">
					<div class="self_td" v-for="item in text.abilitys" :key="item.id">
						{{item.abilityTypeName}}-
						{{item.firstAbilityName}}-
						{{item.secondAbilityName}}
					</div>
				</div>

        <div slot="estimatedTime" slot-scope="text,record">
          {{EstimatedTime(record.estimatedTime)}}
        </div>
        <div slot="device" slot-scope="text,record">
					<span v-for="item in hardwareList" :key="item.id">
						<img style="width: 20px;margin-left: 10px;" :src="item.icon" alt="" v-if="(item.id | text.hardwareRequirements) == text.hardwareRequirements">
					</span>
				</div>
        <div slot="status" slot-scope="text,record" v-auth="`Status`">
          <a-switch checked-children="启用" un-checked-children="禁用" :disabled="text.classifyTag == 1" :checked="record.enabled" @click.native.stop="StatusChange(record)"/>
        </div>
        <div slot="ages" slot-scope="text,record">
          {{record.minAge}} - {{record.maxAge}}
        </div>
        <div slot="action" slot-scope="text,record" class="action" @click.stop="(e) => e.preventDefault()">
          <!--  -->
          <a @click.stop="edit(record)" v-permission="`/content/Traingame/TraingameSeting`" >
            <a-icon type="edit"/>编辑
          </a>
          <a @click.stop="preview(record)" v-permission="`Preview`">预览</a>

          <m-dropdown>
            <a class="ant-dropdown-link" @click.stop="test">
              更多
              <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-permission="`/content/Traingame/Statistics`">
                <a @click.stop="Statistics(record)">统计</a>
              </a-menu-item>
              <!-- v-permission="`Content.Traingame.Match`" -->
              <a-menu-item v-permission="`/content/Traingame/MatchSeting`">
                <a @click.stop="matching(record)">匹配</a>
              </a-menu-item>
              <!-- v-permission="`Content.Traingame.Level`" -->
              <a-menu-item v-permission="`/content/Traingame/LevelSeting`">
                <a @click.stop="levelSeting(record)">关卡</a>
              </a-menu-item>
              <a-menu-item v-permission="`Video`">
                <a @click.stop="video(record)">视频</a>
              </a-menu-item>
              <a-menu-item v-if="record.classifyTag == 4" v-permission="`Convert`">
                <a style="color: #34a852;" @click="toScienceOrBusiness(record)">转商用</a>
              </a-menu-item>
              <a-menu-item v-if="record.classifyTag == 1" v-permission="`Convert`">
                <a style="color:#f90;" @click="toScienceOrBusiness(record)">转科研</a>
              </a-menu-item>
              <a-menu-item v-permission="`Delete`" v-if="text.classifyTag == 4">
                <!-- 商用不可删除、禁用 -->
                <!-- <a-popconfirm title="确定删除？" @confirm="deleteEgame(record)" v-permission="`Content.Traingame.Delete`">
                  <a class="red" style="color: #f00;">删除</a>
                </a-popconfirm> -->
                <a style="color:#f00;" v-if="text.classifyTag == 4" @click="deleteEgame(record)">删除</a>
              </a-menu-item>

            </a-menu>
          </m-dropdown>
        </div>
      </a-table>
    </div>
    <!-- 关联视频 -->
    <a-modal v-model="relationModle.visible" title="关联视频" @ok="relationOk" width="50%">
        <a-form-model
            ref="ruleForm"
            :model="relationModle"
            :rules="relationRules"
            :label-col="{span:6}"
            :wrapper-col="{span:14}"
        >
            <a-form-model-item :ref="'Part' + (index + 1)" :label="'Part' + (index + 1)" class="part" v-for="(item,index) in relationModle.part" :key="index">
                <div class="inBox" @click="pick(item,index)">{{item.contentName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.firstAbilityName}}</div>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
    <!-- 选择视频 -->
    <a-modal v-model="pickModle.visible" title="选择视频" @ok="pickOk" width="60%">
        <a-form-model layout="inline">
            <a-form-model-item label="视频名称">
                <a-input placeholder="请输入视频名称" allow-clear :maxLength="20" v-model="pickModle.name" @keyup.enter="getList(1)"/>
            </a-form-model-item>
            <a-form-model-item label="一级能力">
                <a-tree-select
                    v-model="pickModle.firstAbilityId"
                    treeDefaultExpandAll
                    style="width:172px;"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    placeholder="选择一级能力"
                    allow-clear
                    >
                    <a-tree-select-node :key="items.id" :title="items.name" :value="items.id" v-for="items in treeData" :selectable="false">
                        <template v-if="items.children">
                        <a-tree-select-node :key="item.id" :title="item.name" :value="item.id" v-for="item in items.children">
                            <template v-if="item.children">
                            <a-tree-select-node :key="el.id" :title="el.name" :value="el.id" v-for="el in item.children"/>
                            </template>
                        </a-tree-select-node>
                        </template>
                    </a-tree-select-node>
                </a-tree-select>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="getModleList(1);">查询</a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="table" style="margin-top:25px;">
            <a-table
                :columns="videoColumns"
                row-key="id"
                ref="videoTable"
                :row-selection="rowSelection"
                :pagination="tableRelevant.tablePagination"
                :loading="tableRelevant.tableLoading"
                :locale="tableRelevant.locale"
                :dataSource="tableRelevant.tableDataSource">
                <div slot="firstAbilityName" slot-scope="text,record">
                    <div v-for="item in record.abilitys" :key="item.id">
                        <span v-if="item.firstAbilityName == item.firstAbilityId"></span>
                        <span v-else>{{item.firstAbilityName}}</span>
                    </div>
                </div>
            </a-table>
        </div>
    </a-modal>
    <a-drawer
			width="600"
			title="游戏详情"
			placement="right"
			:visible="drawer.visible"
			@close="onClose"
			>
			<div class="card">
				<h5>基本信息</h5>
        <div class="item">
					<span>版本号</span>
					<em v-if="drawer.data.version">{{ drawer.data.version}}</em>
          <em v-else>无</em>
				</div>
        <div class="item">
					<span>适用性别</span>
					<em>{{ drawer.data.applicableGender == 1 ? '男' : drawer.data.applicableGender == 2 ? '女' : '均可' }}</em>
				</div>
				<div class="item">
					<span>适用年龄</span>
					<em v-if="drawer.data.minAge && drawer.data.maxAge">{{drawer.data.minAge}} - {{ drawer.data.maxAge }}岁</em>
					<em v-else>无</em>
				</div>
				<div class="item">
					<span>最佳年龄</span>
					<em v-if="drawer.data.optimumAge">{{ drawer.data.optimumAge }}岁</em>
					<em v-else>无</em>
				</div>
				<div class="item">
					<span>设备要求</span>
					<em v-if="drawer.data.hardwareRequirements > 0">
						<i v-for="item in hardwareList" :key="item.id" style="font-style: normal;">
              <img :src="item.icon" style="width: 20px;" alt="" v-if="(item.id | drawer.data.hardwareRequirements) == drawer.data.hardwareRequirements">
							{{ (item.id | drawer.data.hardwareRequirements) == drawer.data.hardwareRequirements ? item.name : ''}}
						</i>
					</em>
					<em v-else>无</em>
				</div>
				<div class="item">
					<span>课程体系</span>
					<em v-if="drawer.data.suitableCourses.length ">
						<i v-for="item in drawer.data.suitableCourses" :key="item.id" style="font-style: normal;">
							{{ item }}
						</i>
					</em>
					<em v-else>无</em>
				</div>
			</div>
		</a-drawer>
  </a-card>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import {EstimatedTime} from "@/utils/EstimatedTime";

const columns = [
  { title: '游戏名', dataIndex: 'name', key: 'name'},
  { title: '版本名称', dataIndex: 'versionName', key: 'versionName'},
  { title: '质量标准', scopedSlots: { customRender: 'classifyTag' }, align:'center', key: 'classifyTag'},
  { title: '能力维度', class:'testClass',width:250, key: 'abilityTypeName', align:'center', scopedSlots: { customRender: 'abilityTypeName' }},
  { title: '适用年龄', scopedSlots: { customRender: 'ages' }, align:'center', key: 'createTime',width:100, },
  { title: '用时', scopedSlots: { customRender: 'estimatedTime' }, align:'center', key: 'time'},
  { title: '设备要求', scopedSlots: { customRender: 'device' }, align:'center', key: 'device'},
  { title: '创建时间', align: 'center', key: 'createTime', dataIndex: 'createTime', sorter: true },
	{ title: '修改时间', align: 'center', key: 'updateTime', dataIndex: 'updateTime', sorter: true },
  { title: '状态', key: 'status', align:'center', scopedSlots: { customRender: 'status' }},
  { title: '操作', key: 'action', align:'center', scopedSlots: { customRender: 'action' }},
];

const videoColumns = [
    { title: '视频名称', key: "1", dataIndex:'contentName'},
    { title: '一级能力', key: "2", scopedSlots: {customRender: 'firstAbilityName'}},
    { title: '视频时长', key: "3", dataIndex:'endTime'},
    { title: '备注', key: "4", dataIndex:'remark'}
]
export default {
  name:'Traingame',
  data () {
    return {
        EstimatedTime,
        advanced: false,
        istoggleAdvanced: false, //是否显示展开按钮
        dataSource:[],
        columns,
        total: 0,
        options:[],
        selectId:[],
        search:{
            PageIndex:1,
            PageSize:10,
            ContentType: 2,
            Name:'',
            versionName: undefined,
            AbilityTypeId:'',
            FirstAbilityId:'',
            SecondAbilityId:'',
            classifyTag:undefined,
            Enabled:undefined,
            minAge: undefined,

		    maxAge: undefined,
        },
        hardwareList:[
				{id:4,name:'耳机',icon:require('@/assets/img/ej.png')},
				{id:8,name:'麦克风',icon:require('@/assets/img/mkf.png')},
				{id:32,name:'陀螺仪',icon:require('@/assets/img/tly.png')}
			],//设备
        statusType:'',
        // 匹配
        matchingModal:false,
        loading:true,
        //关联视频
        relationModle:{
            visible:false,
            part:[
                {contentName:'',firstAbilityName:''},
                {contentName:'',firstAbilityName:''},
                {contentName:'',firstAbilityName:''},
            ]

        },
        relationRules:{

        },
        //选择视频
        pickModle:{
            visible:false,
            name:'',
            firstAbilityId:undefined
        },
        videoColumns,
        tableRelevant: tableRelevant.call(this,this.getModleList),
        conselectedRow:[],
        currentPart:0,
        selectedRows:[],
        treeData:[],
        contentId:'',
        oldRadioValue: "",

        // 抽屉
        drawer:{
          visible:false,
          data:{
            versionName:'',
            applicableGender:'',
            minAge:'',
            maxAge:'',
            optimumAge:'',
            hardwareRequirements:'',
            suitableCourses:[],
          },
        },
        // 点击行
        customRow: (record, index) => ({
            on: {
                click: () => {
                  this.getDetailByid(record)
                }
            }
        }),
    }
  },

  created () {
    this.initSearch()
    this.getList()
    this.abilityTypeSelect(0)
  },
  watch:{
        "pickModle.visible"(now){
            if(!now){
                this.pickModle.name = ''
                this.pickModle.firstAbilityId = ''
            }
        }
    },
    computed: {
        rowSelection() {
            return {
                type:'radio',
                selectedRowKeys: this.conselectedRow,
                onChange: (selectedRowKeys, selectedRows) => {
                    if(selectedRowKeys[0] === this.conselectedRow[0]){
                        this.conselectedRow = [];
                    } else {
                        this.conselectedRow = selectedRowKeys;
                        this.selectedRows = selectedRows;
                    }
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: this.relationModle.part.filter((f, i) => i !== this.currentPart && f.id === record.id).length > 0,
                    },
                }),
            };
        }
    },
  methods: {
    changeSort(_, __, sort) {
      const { order='',field} = sort
      if (!order) {
        return
      }
      const map = {
        ascend:'Asc',
        descend:'Desc'
      }
      if(field=='createTime'){
        this.search.createDesc = map[order]
        this.search.updateDesc = undefined
      }
      if(field=='updateTime'){
        this.search.updateDesc = map[order]
        this.search.createDesc = undefined
      }
      this.getList()
    },
    Statistics(text){
			this.$store.commit("content/setTrainGameInfo", text);
			window.open('/content/Traingame/Statistics?type=2&name=' + text.name + '&versionName=' + text.versionName);
		},
    // 获取详情
		getDetailByid(record){
			let params = {
				id: record.id
			}
			this.$http.getDetailByid(params)
			.then(res =>{
				this.drawer.visible = true;
				this.drawer.data = {
					version:res.data.data.versions[0].version,
					applicableGender:res.data.data.applicableGender,
					minAge:res.data.data.minAge,
					maxAge:res.data.data.maxAge,
					optimumAge:res.data.data.optimumAge,
					hardwareRequirements:res.data.data.hardwareRequirements,
					suitableCourses:res.data.data.suitableCourses,
				};
			})
		},
      onClose(){
        this.drawer.visible = false
      },
      initSearch(){
          this.search.Name = this.$route.query.Name;
          this.search.versionName = this.$route.query.versionName;
          this.search.Enabled = this.$route.query.Enabled;
          this.search.PageIndex = Number(this.$route.query.PageIndex) || 1;
          this.search.PageSize = Number(this.$route.query.PageSize) || 10;
          this.search.AbilityTypeId = Number(this.$route.query.AbilityTypeId) || undefined;
          this.search.FirstAbilityId = Number(this.$route.query.FirstAbilityId) || undefined;
          this.search.SecondAbilityId = Number(this.$route.query.SecondAbilityId) || undefined;
          this.search.minAge = Number(this.$route.query.minAge) || undefined;
          this.search.maxAge = Number(this.$route.query.maxAge) || undefined;
          if (this.search.AbilityTypeId){
              this.selectId = [this.search.AbilityTypeId];
          }
          if (this.search.FirstAbilityId){
              this.selectId = [this.search.AbilityTypeId, this.search.FirstAbilityId];
          }
          if (this.search.SecondAbilityId){
              this.selectId = [this.search.AbilityTypeId, this.search.FirstAbilityId, this.search.SecondAbilityId];
          }
      },
      setQuery(){
          const query = {};
          for (const key in this.search) {
              if (this.search[key] && typeof this.search[key] !== "object") {
                  query[key] = this.search[key]
              }
          }
          this.$router.push({query})
      },
    searchList(){
      this.loading = true
      this.search.PageIndex = 1
      this.getList()
    },
    StatusChange(record){
        this.$message.destroy();
        const fn = () => {
            let formData = new FormData();
            formData.append('id', record.id);
            this.loading = true;
            this.$http.updatestatus(formData).then(res => {
                this.loading = false;
                record.enabled = !record.enabled;
                this.$message.success('修改成功');
            });
        };
        if (record.enabled) {
            this.$confirm({
                title: `确认禁用【${record.name}】`,
                content: "游戏禁用后，已配置的课程将移除该游戏且不可恢复，请谨慎操作",
                centered: true,
                onOk: fn
            });
            return
        }
        let formData = new FormData();
        formData.append("id", record.id);
        formData.append("enabled", false);
        this.loading = true;
        this.$http.contentCheckStatus(formData).then(res => {
            fn();
        });
    },
    onChange(value) {
      this.search.AbilityTypeId = value[0]
      this.search.FirstAbilityId = value[1]
      this.search.SecondAbilityId = value[2]
      this.selectId = value
    },
    loadData(selectedOptions){
        return new Promise((resolve, reject) => {
            const targetOption = selectedOptions[selectedOptions.length - 1];
            targetOption.loading = true;
            targetOption.children = [];
            let params = {
                pid: targetOption.id,
                abilityType:0
            };
            this.$http.abilitySelect(params).then(res => {
                targetOption.loading = false;
                targetOption.children = res.data.data.map(m => ({...m, value: m.id,label: m.name,isLeaf: m.levelNumber > 1}))
                this.options = [...this.options];
                resolve(targetOption.children)
            });
        })
    },
    abilityTypeSelect(level){
      let params = {
        level:level,
        abilityType:0
      };
      this.$http.abilitySelect(params)
      .then(res => {
        this.options = res.data.data
          this.options.forEach(item=>{
            item.value = item.id
            item.label = item.name
            item.isLeaf = false
          })
            if (this.search.AbilityTypeId){
                this.loadData(this.options.filter(f => f.id === this.search.AbilityTypeId)).then(data => {
                    if (this.search.FirstAbilityId){
                        this.loadData(data.filter(f => f.id === this.search.FirstAbilityId))
                    }
                })
            }
      });
    },
    addEgame(){
      this.$store.commit("content/setTrainGameInfo", '')
      this.$router.push({
        path:'/content/Traingame/TraingameSeting',
        query: {
          type: "add"
        }
      })
    },
    edit(record){

        this.$store.commit("content/setTrainGameInfo", {fullPath: this.$route.fullPath, ...record})
        sessionStorage.setItem("currentId", record.id);//id
        sessionStorage.setItem("name", record.name);//name
        sessionStorage.setItem("currentEnabled", record.enabled);//name
        this.$router.push({
          path:'/content/Traingame/TraingameSeting',
          query:{
            type:"edit",
            id:record.id,
              name: record.name,
              versionName: record.versionName,
          }
        })
    },
    getList() {
      for (let paramsKey in this.search) {
        if (this.search[paramsKey] === null) {
          this.search[paramsKey] = undefined;
        }
      }
        this.setQuery();
      this.$http.contentlist(this.search)
      .then(res => {
          this.dataSource = res.data.items.map(v => ({...v, childTableData: [], childTableLoading: false}));
          this.total = res.data.totalCount
      }).finally(() =>this.loading = false)

    },
    deleteEgame(record){
        this.$confirm({
            title: `确认删除【${record.name}】`,
            content: "游戏删除后所有相关数据都将删除且不可恢复，请谨慎操作",
            centered: true,
            onOk: () => {
                let formData = new FormData();
                formData.append('contentId',record.id);
                this.loading = true;
                this.$http.deleteEGamege(formData).then(res => {
                    this.loading = false;
                    this.getList();
                    this.$message.success('删除成功');
                });
            }
        });
    },
    onPageChange(page, size) {
      this.search.PageIndex = page;
      this.getList();
    },
    onSizeChange(page, size) {
      this.search.PageIndex = 1;
      this.search.PageSize = size;
      this.getList();
    },
    resetSearch(){
      this.search = {
        PageIndex:1,
        PageSize:10,
        ContentType: 2,
        Name: "",
          versionName: undefined,
        AbilityTypeId: "",
        FirstAbilityId: "",
        SecondAbilityId: "",
        Enabled: undefined
      }
      this.selectId = []
      this.getList()
    },
    toScienceOrBusiness(text){
      let tit = text.classifyTag == 1 ? '科研' : '商用'
      this.$confirm({
				title: `确认将该游戏转为${tit}游戏？`,
				centered: true,
				onOk: () => {
					let formData = new FormData();
					formData.append('ContentId',text.id)
					formData.append('classifyTag',text.classifyTag == 1 ? 4 : 1)
					this.$message.destroy();
					this.$http.UpdataClassifyTag(formData)
					.then(res => {
						const {status, data, message} = res.data;
							this.$message.success('操作成功')
							this.getList(1);

					});
				}
			});
    },
    //预览
    preview(val) {
        this.$message.destroy();
        if (val.uri) {
            const base_api = process.env.VUE_APP_API_BASE_URL.slice(7);
            const Url = `${val.uri}?url=${base_api}&userid=63b44c73-a040-4c06-bb20-752614fc098b&userName=%E5%B0%8F%E5%A4%8F2&firstplay=1&sendStartFlag=true&stage=1&contentId=
            ${val.id}&maxStage=${val.maxStage || 30}`;
            window.open(Url);
        } else {
            this.$message.error("预览失败")
        }
    },
    // 匹配
    matching(record){
        this.$store.commit("content/setTrainGameInfo", {fullPath: this.$route.fullPath, ...record})
      this.$router.push({
        path: '/content/Traingame/MatchSeting',
        query: {
          id:record.id,
          name:record.name
        }
      })
    },
    // 关卡
    levelSeting(record){
        this.$store.commit("content/setTrainGameInfo", {fullPath: this.$route.fullPath, ...record})
      this.$router.push({
        path: '/content/Traingame/LevelSeting',
        query: {
          id:record.id,
          name:record.name
        }
      })
    },

    getSelect() {
        let params = {
            isSelect:true,
            abilityType:0
        };
        this.$http.loadallsel(params)
        .then(res => {
                this.treeData = res.data.data
            });
    },
    video(text){
        this.relationModle = {
            visible:false,
            part:[
                {contentName:'',firstAbilityName:''},
                {contentName:'',firstAbilityName:''},
                {contentName:'',firstAbilityName:''},
            ]
        }
        this.getVideoInfo(text)
        this.contentId = text.id
        this.getSelect()
    },
    getVideoInfo(text){
        let params = {
            contentId:text.id
        }
        this.$http.GetContentRelevanceByContentId(params)
        .then(res => {
            const { data} = res.data;
            this.relationModle.visible = true
            if (data.length) {
                this.relationModle.part = this.relationModle.part.map((m ,i) => {
                    if(data[i]){
                        return {
                            contentName: data[i].linkContentName,
                            firstAbilityName: data[i].linkContentAbilityName,
                            id: data[i].linkContentId
                        }
                    }
                    return m
                })
            }
        })
        .catch(err =>{
            // this.loading = false
        })
    },
    getModleList(pageIndex){
        let params = {
            pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
            pageSize: this.tableRelevant.tablePagination.pageSize,
            name: this.pickModle.name,
            firstAbilityId: this.pickModle.firstAbilityId,
            ContentType:4,
            ScientificName:'游戏指导'
        }
        this.$http.EGamegelist(params)
        .then(res => {
            this.tableExpandedRowKeys = [];
            // this.tableRelevant.tableDataSource = res.data.data.items;
             res.data.data.items.forEach(v=>{
                v.firstAbilityName = v.abilitys.length ? v.abilitys[0].firstAbilityName : ''
            })
            this.tableRelevant.tableDataSource = res.data.data.items
            this.tableRelevant.tablePagination.total = res.data.data.totalCount;
            this.tableRelevant.tablePagination.current = res.data.data.pageIndex;
        })
        .catch(err =>{
            this.loading = false
        })
    },
    // 关联视频
    relationOk(){
        let params = {
            contentId:this.contentId,
            links:[]
        }
        let arr = []
        console.log(this.relationModle.part)
        this.relationModle.part.forEach((v,i)=>{
            let str = {
                linkContentId:'',
                relevanceType:1,
                sortIndex:i+1,
            }
            if(v.id){
                str.linkContentId = v.id
                arr.push(str)
            }
        })
        params.links = arr
        console.log(params)
        this.$http.RelevanceVideo(params)
        .then(() => {
            this.$message.success('关联成功')
            this.relationModle = {
                visible:false,
                part:[
                    {contentName:'',firstAbilityName:''},
                    {contentName:'',firstAbilityName:''},
                    {contentName:'',firstAbilityName:''},
                ]
            }
        })
        .catch(err =>{
            this.$message.error('系统异常')
        })
    },
    pick(item,index){
        this.conselectedRow = []
        this.pickModle.visible = true
        this.currentPart = index
        this.conselectedRow.push(this.relationModle.part[index].id)
        this.getModleList(1);
        this.$nextTick(() => {
           this.$refs.videoTable.$el.addEventListener("click", this.cancelTableRadio, true);
        })
    },
    //选择视频
    pickOk(){
        if(!this.relationModle.part.filter(f => f.id).length){
            if(!this.selectedRows.length){
                this.$message.destroy();
                this.$message.error('请选择视频')
                return
            }
        }


        if(this.selectedRows.length){
            this.relationModle.part[this.currentPart] = this.selectedRows[0]
            this.pickModle.visible = false
        }else{
            this.relationModle.part[this.currentPart] = {contentName:'',firstAbilityName:''}
            this.pickModle.visible = false
        }
        this.selectedRows = []
    },
    cancelTableRadio(ev){
        const e = ev || event;
        if(typeof e.target.checked === "boolean"){
            if(this.oldRadioValue == e.target.value){
                this.conselectedRow = [];
                this.selectedRows = [];
            } else {
                this.oldRadioValue = e.target.value;
            }
            //e.target.checked = !e.target.checked
        }
    }
  }
}
</script>

<style scoped>
 .Traingame >>> .standard-table .alert {
  display: none !important;
}

.Traingame >>>  .searchForm{
  display:flex;

}
.Traingame >>> .searchForm .fold{
    width: 91%;
    display:flex;
  }
  .sbtn{
    display: flex;
    align-items: center;
    height: 40px;
  }
</style>
<style lang="less" scoped>
.card{
	h5{
		margin-top: 15px;
		font-size: 18px;
		font-weight: 600;
	}
	.item{
		display: flex;
		align-items: center;
		margin-top: 15px;
		padding: 0 5px;
		span{
			color:#8f8f8f;
      display: inline-block;
      width: 56px;
		}
		em{
			font-style: normal;
			margin-left: 15px;
			color: #000;
		}
	}
}
/deep/ .ant-table-tbody .testClass{
  padding: 0 !important;
}
.self_td{
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}
.inBox{
    height:32px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor:pointer;
    display: flex;
    align-items: center;
    padding: 0 10px;
}
.inBox:hover{
    border-color: #36cfc9;
    border-right-width: 1px !important;
}
.part{
    display:flex;
    align-items: center;
}
</style>

